import { useEffect, useState } from "react";
import { PlusCircleOutlined } from "@ant-design/icons";
import { ContextStatus } from '@leedpulse-monorepo/enums';
import { useAdminsController } from "../../contexts/data/admins/AdminsContext";
import { Drawer, Tabs } from "antd";
import { IAdmin } from "@leedpulse-monorepo/interfaces";
import AdminDetails from "../../components/admins_page/AdminDetails";
import AdminCreationForm from "../../components/admins_page/AdminCreationForm";
import LoadingCurtain from "../../components/@shared/LoadingCurtain";

interface AdminsMenuProps {
    isAdminsOpened: { open: boolean, tab?: string };
    onClose: () => void;
}

const AdminsMenu: React.FC<AdminsMenuProps> = ({ isAdminsOpened, onClose }) => {
    const adminsController = useAdminsController();

    const [activeKey, setActiveKey] = useState<string | undefined>(isAdminsOpened.tab);

    const handleAdminCreated = async (newAdminId: string) => {
        await adminsController.fetchEnabled();
        setActiveKey(newAdminId);
    };

    const handleAdminUpdated = async () => {
        await adminsController.fetchEnabled();
    };

    const handleAdminDeleted = async () => {
        await adminsController.fetchEnabled();
        setActiveKey(undefined);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            adminsController.fetchEnabled();
        }, 400);

        return () => clearTimeout(timer);
    }, []);

    // Ajuste pendant le rendu (pattern « ajuster l'etat quand une prop change » de
    // la doc React) : dans un effet, ce recalcul coutait un second rendu.
    const [lastAdminsOpened, setLastAdminsOpened] = useState(isAdminsOpened);
    if (isAdminsOpened !== lastAdminsOpened) {
        setLastAdminsOpened(isAdminsOpened);
        if (isAdminsOpened.tab) {
            setActiveKey(isAdminsOpened.tab);
        }
    }

    return (
        <div>
            <Drawer
                title="🗒️ Configurations"
                width={"80vw"}
                placement={'right'}
                closable={false}
                onClose={() => onClose()}
                open={isAdminsOpened.open}
                key={'right'}
                styles={{
                    body: {
                        display: 'flex',
                        flexDirection: 'column'
                    }
                }}
            >
                {adminsController.status === ContextStatus.SUCCESS ? <Tabs
                    activeKey={activeKey}
                    onChange={(key) => setActiveKey(key as string)}
                    items={[
                        ...adminsController.enabledResults.map((admin: IAdmin) => ({
                            key: admin.id,
                            label: `${admin.application?.app_name} (${admin.id})`,
                            children: <AdminDetails admin={admin} onCreated={handleAdminCreated} onUpdated={handleAdminUpdated} onDeleted={handleAdminDeleted} />
                        })), {
                            key: 'add',
                            label: <PlusCircleOutlined />,
                            children: <AdminCreationForm onCreated={handleAdminCreated} />,
                        }]}
                /> : <LoadingCurtain />}
            </Drawer>
        </div>
    );
};

export default AdminsMenu;
